//settings

var DEFAULT_BUTTON = {
  textStyle: new PIXI.TextStyle({
    fontFamily: "manrope-bold",
    fontSize: 32,
    fill: ["#000000"],
    align: "center",
  }),

  hoverTextStyle: new PIXI.TextStyle({
    fontFamily: "manrope-bold",
    fontSize: 32,
    fill: ["#FFFFFF"],
    align: "center",
  }),

  disabledTextStyle: new PIXI.TextStyle({
    fontFamily: "manrope-bold",
    fontSize: 32,
    fill: ["#AAAAAA"],
    align: "center",
  }),

  selectedTextStyle: new PIXI.TextStyle({
    fontFamily: "manrope-bold",
    fontSize: 32,
    fill: ["#000000"],
    align: "center",
  }),

  width: 200,
  height: 100,
  yOffset: 0,
  borderRadius: 300,
  hitAreaX: 1.25,
  hitAreaY: 1.25,
  imgHeight: 50,
  fadeDuration: 200,
  clickSound: "btnClick",

  fill1: [0xffffff, 0],
  fill2: [0xffffff, 0],
  line1: [0, 0x000000, 0],
  line2: [0, 0x000000, 0],
  imgColor: [0xffffff, 1],

  hoverFill1: [0x000000, 0.05],
  hoverFill2: [0x000000, 0],
  hoverLine1: [0, 0x000000, 0],
  hoverLine2: [0, 0x000000, 0],
  hoverImgColor: [0xffffff, 1],

  disabledFill1: [0x555555, 0],
  disabledFill2: [0x000000, 0],
  disabledLine1: [0, 0xdddddd, 0],
  disabledLine2: [0, 0x000000, 0],
  disabledImgColor: [0xffffff, 1],

  selectedFill1: [0xeeeeee, 0],
  selectedFill2: [0xcccccc, 0],
  selectedLine1: [0, 0xffffff, 0],
  selectedLine2: [0, 0x000000, 0],
  selectedImgColor: [0xffffff, 1],
};

var ICON_BUTTON = JSON.parse(JSON.stringify(DEFAULT_BUTTON));
ICON_BUTTON.width = 100;
ICON_BUTTON.height = 100;

var PU_BUTTON = JSON.parse(JSON.stringify(DEFAULT_BUTTON));
PU_BUTTON.fill1 = [0xffffff, 0.75];
PU_BUTTON.hoverFill1 = [0xffffff, 1];
PU_BUTTON.disabledFill1 = [0x000000, 0.05];
PU_BUTTON.disabledImgColor = [0xffffff, 0.25];
PU_BUTTON.width = 100;
PU_BUTTON.height = 100;
PU_BUTTON.imgHeight = 75;

var TEXT_BUTTON = JSON.parse(JSON.stringify(DEFAULT_BUTTON));
TEXT_BUTTON.width = 150;

var PLAY_BUTTON = JSON.parse(JSON.stringify(DEFAULT_BUTTON));
PLAY_BUTTON.width = 300;
PLAY_BUTTON.height = 300;
PLAY_BUTTON.imgHeight = 180;

var LOADING_BUTTON = JSON.parse(JSON.stringify(PLAY_BUTTON));
LOADING_BUTTON.imgColor = [0xffffff, 0.9];
LOADING_BUTTON.hoverImgColor = [0xffffff, 1];
LOADING_BUTTON.fill1 = [0xffffff, 1];
LOADING_BUTTON.hoverFill1 = [0xffffff, 1];

var SHIFT_BUTTON = JSON.parse(JSON.stringify(DEFAULT_BUTTON));
SHIFT_BUTTON.width = 125;
SHIFT_BUTTON.height = 125;
SHIFT_BUTTON.imgHeight = 33;
(SHIFT_BUTTON.hitAreaX = 1.5), (SHIFT_BUTTON.hitAreaY = 1.5);

var RESTART_BUTTON = JSON.parse(JSON.stringify(DEFAULT_BUTTON));
RESTART_BUTTON.width = 200;
RESTART_BUTTON.height = 200;
RESTART_BUTTON.imgHeight = 100;

var POPUP_BUTTON = JSON.parse(JSON.stringify(DEFAULT_BUTTON));
POPUP_BUTTON.width = 275;
POPUP_BUTTON.height = 70;

///////////////////////////
//button class

function Button(parent, textKey, img, callback, style) {
  var yOffset = 10;
  var btn = new Container(parent);
  style = style || DEFAULT_BUTTON;
  if (Array.isArray(textKey)) {
    btn.textList = textKey;
    btn.currentTextIndex = 0;
    textKey = textKey[0];
  }
  if (Array.isArray(img)) {
    btn.imgList = img;
    btn.currentImgIndex = 0;
    img = img[0];
  }
  var text = textKey;
  if (getText(textKey)) {
    btn.textKey = textKey;
    text = getText(textKey);
  }
  btn.style = style;
  btn.callback = callback;
  btn.transparent = new WhiteRectangle(btn, [style.width * style.hitAreaX, (style.height + style.yOffset) * style.hitAreaY]);
  btn.transparent.alpha = 0;

  btn.backRect = new Rectangle(btn, [style.width, style.height + style.yOffset, style.borderRadius]);
  btn.backRect.tint = style.fill2[0];
  btn.backRect.alpha = style.fill2[1];
  btn.backLine = new Rectangle(btn, [style.width, style.height + style.yOffset, style.borderRadius], [style.line2[0], 0xffffff, 1], [0xffffff, 0]);
  btn.backLine.tint = style.line2[1];
  btn.backLine.alpha = style.line2[2];
  btn.frontRect = new Rectangle(btn, [style.width, style.height, style.borderRadius]);
  btn.frontRect.y = -style.yOffset * 0.5;
  btn.frontRect.tint = style.fill1[0];
  btn.frontRect.alpha = style.fill1[1];
  btn.frontLine = new Rectangle(btn, [style.width, style.height, style.borderRadius], [style.line1[0], 0xffffff, 1], [0xffffff, 0]);
  btn.frontLine.y = -style.yOffset * 0.5;
  btn.frontLine.tint = style.line1[1];
  btn.frontLine.alpha = style.line1[2];
  btn.frontRect.startY = btn.frontRect.y;
  btn.frontRect.downY = btn.frontRect.y + style.yOffset;

  (btn.textBox = new Text(btn, text, style.textStyle)), (btn.textBox.y = -style.yOffset * 0.5);
  btn.textBox.startY = btn.textBox.y;
  btn.textBox.downY = btn.textBox.y + style.yOffset;

  if (img) {
    btn.img = new Sprite(btn, img);
    btn.img.position.set(0, -style.yOffset * 0.5);
    btn.img.anchor.set(0.5);
    var ratio = btn.img.width / btn.img.height;
    btn.img.height = style.imgHeight;
    btn.img.width = style.imgHeight * ratio;
    btn.img.tint = style.imgColor[0];
    btn.img.alpha = style.imgColor[1];
    btn.img.startY = btn.img.y;
    btn.img.downY = btn.img.y + style.yOffset;

    if (text) {
      btn.img.x = -style.width * 0.5 + btn.img.width * 0.5 + (style.height - btn.img.height) * 0.5;
      btn.textBox.x = ((style.height - btn.img.height) * 0.5 + btn.img.width) * 0.5;
    }
  }

  btn.interactive = true;
  btn.buttonMode = true;
  btn.isPressed = false;

  btn.disable = function () {
    btn.interactive = false;
    fadeToColor(btn.frontRect, btn.style.disabledFill1[0], btn.style.disabledFill1[1], btn.style.fadeDuration);
    fadeToColor(btn.frontLine, btn.style.disabledLine1[1], btn.style.disabledLine1[2], btn.style.fadeDuration);

    fadeToColor(btn.backRect, btn.style.disabledFill2[0], btn.style.disabledFill2[1], btn.style.fadeDuration);
    fadeToColor(btn.backLine, btn.style.disabledLine2[1], btn.style.disabledLine2[2], btn.style.fadeDuration);
    btn.textBox.style = btn.style.disabledTextStyle;
    if (btn.img) {
      fadeToColor(btn.img, btn.style.disabledImgColor[0], btn.style.disabledImgColor[1], btn.style.fadeDuration);
    }
  };
  btn.enable = function () {
    btn.interactive = true;
    fadeToColor(btn.frontRect, btn.style.fill1[0], btn.style.fill1[1], btn.style.fadeDuration);
    fadeToColor(btn.frontLine, btn.style.line1[1], btn.style.line1[2], btn.style.fadeDuration);

    fadeToColor(btn.backRect, btn.style.fill2[0], btn.style.fill2[1], btn.style.fadeDuration);
    fadeToColor(btn.backLine, btn.style.line2[1], btn.style.line2[2], btn.style.fadeDuration);
    btn.textBox.style = btn.style.textStyle;
    if (btn.img) {
      fadeToColor(btn.img, btn.style.imgColor[0], btn.style.imgColor[1], btn.style.fadeDuration);
    }
  };

  btn.setText = function (newText) {
    if (getText(newText)) {
      btn.textKey = newText;
      newText = getText(newText);
    }
    btn.textBox.text = newText;
  };

  btn.setImg = function (newTexture) {
    if (!btn.img) return;

    if (PIXI.utils.TextureCache[newTexture]) btn.img.texture = PIXI.utils.TextureCache[newTexture];
    else btn.img.texture = PIXI.Texture.fromImage(newTexture);

    btn.img.scale.set(1);
    var ratio = btn.img.width / btn.img.height;
    btn.img.height = style.imgHeight;
    btn.img.width = style.imgHeight * ratio;
  };

  btn.onPointerDown = function (e) {
    btn.isPressed = true;
    btn.frontRect.y = btn.frontRect.downY;
    btn.frontLine.y = btn.frontRect.downY;
    btn.textBox.y = btn.textBox.downY;
    if (btn.img) {
      btn.img.y = btn.img.downY;
    }
  };
  btn.on("pointerdown", btn.onPointerDown);

  btn.onMouseUp = function (e) {
    if (!btn.isPressed) return;
    if (btn.group != undefined) return;
    if (btn.callback) btn.callback(e);

    if (btn.style.clickSound) playSound(btn.style.clickSound);

    btn.isPressed = false;
    btn.frontRect.y = btn.frontRect.startY;
    btn.frontLine.y = btn.frontRect.startY;
    btn.textBox.y = btn.textBox.startY;
    fadeToColor(btn.frontRect, btn.style.hoverFill1[0], btn.style.hoverFill1[1], btn.style.fadeDuration);
    fadeToColor(btn.frontLine, btn.style.hoverLine1[1], btn.style.hoverLine1[2], btn.style.fadeDuration);

    fadeToColor(btn.backRect, btn.style.hoverFill2[0], btn.style.hoverFill2[1], btn.style.fadeDuration);
    fadeToColor(btn.backLine, btn.style.hoverLine2[1], btn.style.hoverLine2[2], btn.style.fadeDuration);
    btn.textBox.style = btn.style.hoverTextStyle;
    if (btn.img) {
      btn.img.y = btn.img.startY;
      fadeToColor(btn.img, btn.style.hoverImgColor[0], btn.style.hoverImgColor[1], btn.style.fadeDuration);
    }

    if (btn.textList) {
      btn.currentTextIndex = (btn.currentTextIndex + 1) % btn.textList.length;
      btn.setText(btn.textList[btn.currentTextIndex]);
    }
    if (btn.imgList) {
      btn.currentImgIndex = (btn.currentImgIndex + 1) % btn.imgList.length;
      btn.setImg(btn.imgList[btn.currentImgIndex]);
    }
  };
  btn.on("mouseup", btn.onMouseUp);

  btn.onTouchEnd = function (e) {
    if (!btn.isPressed) return;
    if (btn.group != undefined) return;
    if (btn.callback) btn.callback(e);

    if (btn.style.clickSound) playSound(btn.style.clickSound);

    btn.isPressed = false;
    btn.frontRect.y = btn.frontRect.startY;
    btn.frontLine.y = btn.frontRect.startY;
    btn.textBox.y = btn.textBox.startY;
    if (btn.img) {
      btn.img.y = btn.img.startY;
    }
    if (btn.textList) {
      btn.currentTextIndex = (btn.currentTextIndex + 1) % btn.textList.length;
      btn.setText(btn.textList[btn.currentTextIndex]);
    }
    if (btn.imgList) {
      btn.currentImgIndex = (btn.currentImgIndex + 1) % btn.imgList.length;
      btn.setImg(btn.imgList[btn.currentImgIndex]);
    }
  };
  btn.on("touchend", btn.onTouchEnd);

  btn.onTouchOutside = function (e) {
    btn.isPressed = false;
    btn.frontRect.y = btn.frontRect.startY;
    btn.frontLine.y = btn.frontRect.startY;
    btn.textBox.y = btn.textBox.startY;
    if (btn.img) {
      btn.img.y = btn.img.startY;
    }
  };
  btn.on("touchendoutside", btn.onTouchOutside);

  btn.onMouseOver = function (e) {
    fadeToColor(btn.frontRect, btn.style.hoverFill1[0], btn.style.hoverFill1[1], btn.style.fadeDuration);
    fadeToColor(btn.frontLine, btn.style.hoverLine1[1], btn.style.hoverLine1[2], btn.style.fadeDuration);

    fadeToColor(btn.backRect, btn.style.hoverFill2[0], btn.style.hoverFill2[1], btn.style.fadeDuration);
    fadeToColor(btn.backLine, btn.style.hoverLine2[1], btn.style.hoverLine2[2], btn.style.fadeDuration);
    btn.textBox.style = btn.style.hoverTextStyle;
    if (btn.img) {
      btn.img.y = btn.img.startY;
      fadeToColor(btn.img, btn.style.hoverImgColor[0], btn.style.hoverImgColor[1], btn.style.fadeDuration);
    }
  };
  btn.on("mouseover", btn.onMouseOver);

  btn.onMouseOut = function (e) {
    btn.isPressed = false;
    btn.frontRect.y = btn.frontRect.startY;
    btn.frontLine.y = btn.frontRect.startY;
    btn.textBox.y = btn.textBox.startY;
    fadeToColor(btn.frontRect, btn.style.fill1[0], btn.style.fill1[1], btn.style.fadeDuration);
    fadeToColor(btn.frontLine, btn.style.line1[1], btn.style.line1[2], btn.style.fadeDuration);

    fadeToColor(btn.backRect, btn.style.fill2[0], btn.style.fill2[1], btn.style.fadeDuration);
    fadeToColor(btn.backLine, btn.style.line2[1], btn.style.line2[2], btn.style.fadeDuration);
    btn.textBox.style = btn.style.textStyle;
    if (btn.img) {
      fadeToColor(btn.img, btn.style.imgColor[0], btn.style.imgColor[1], btn.style.fadeDuration);
      btn.img.y = btn.img.startY;
    }
  };
  btn.on("mouseout", btn.onMouseOut);

  btn.type = "Button";

  btn.delete = function () {
    var elLength = btn.children.length;
    for (var i = elLength - 1; i >= 0; i--) {
      btn.children[i].delete();
    }

    btn.off("mouseout", btn.onMouseOut);
    btn.off("mouseover", btn.onMouseOver);
    btn.off("touchendoutside", btn.onTouchOutside);
    btn.off("touchend", btn.onTouchEnd);
    btn.off("mouseup", btn.onMouseUp);
    btn.off("pointerdown", btn.onPointerDown);
    if (btn.onPointerUp) {
      btn.off("pointerup", btn.onPointerUp);
    }

    parent.removeChild(btn);
    btn.destroy();
    btn = null;
  };

  btn.getName = function () {
    var str = btn.type;

    if (btn.textBox) str += " - " + btn.textBox.text;

    if (btn.img) {
      str += " - " + btn.img.texture.textureCacheIds[0];
    }
    return str;
  };

  return btn;
}

//SpriteButton class
//required: parrent, callback, img (+ "_default.png", "_hover.png", "_pressed.png", "_disabled.png")
//optional: elastic(def: false), hitArea(def: [1, 1]);
//
function SpriteButton(parent, callback, img, elastic, hitArea) {
  elastic = elastic || false;
  hitArea = hitArea || [1, 1];
  hitArea[1] = hitArea[1] || hitArea[0];

  var t = new Container(parent);
  t.type = "Button";
  t.elastic = elastic;
  t.callback = callback;
  t.isPressed = false;
  if (PIXI.utils.TextureCache[img + "_default.png"] != undefined) {
    t.defaultTexture = PIXI.utils.TextureCache[img + "_default.png"];
    t.hoverTexture = PIXI.utils.TextureCache[img + "_hover.png"];
    t.pressedTexture = PIXI.utils.TextureCache[img + "_pressed.png"];
    t.disabledTexture = PIXI.utils.TextureCache[img + "_disabled.png"];
    var b = new Sprite(t, img + "_default.png");
  } else {
    t.defaultTexture = PIXI.utils.TextureCache[img];
    t.hoverTexture = PIXI.utils.TextureCache[img];
    t.pressedTexture = PIXI.utils.TextureCache[img];
    t.disabledTexture = PIXI.utils.TextureCache[img];
    var b = new Sprite(t, img);
  }

  //hit area
  var wr = new WhiteRectangle(t, [b.width * hitArea[0], b.height * hitArea[1]]);
  wr.alpha = 0;
  t.addChild(wr);

  t.interactive = true;
  t.buttonMode = true;

  //events
  t.onTouchEnd = function (e) {
    if (!t.isPressed) return;
    t.callback(e);
    t.isPressed = false;
    if (t.interactive) {
      b.pointerUpStarted = true;
      setTimeout(function () {
        b.texture = t.defaultTexture;
        if (t.elastic) {
          b.targetScale = 1;
          if (b.poinerDownEnded) {
            TweenMax.to(b, 0.3, {
              pixi: {
                scale: b.targetScale,
              },
              ease: Elastic.easeOut.config(1, 0.45),
            });
          }
        }
      }, 50);
    }
  };
  t.on("touchend", t.onTouchEnd);

  t.onTouchOutside = function () {
    t.isPressed = false;
    if (t.interactive) {
      setTimeout(function () {
        b.texture = t.defaultTexture;
        if (t.elastic) {
          TweenMax.to(b, 0.1, {
            pixi: {
              scale: 1,
            },
            ease: Elastic.easeOut.config(1, 0.45),
          });
        }
      }, 50);
    }
  };
  t.on("touchendoutside", t.onTouchOutside);

  t.onMouseUp = function (e) {
    if (!t.isPressed) return;
    t.callback(e);
    t.isPressed = false;
    if (t.interactive) {
      b.pointerUpStarted = true;
      setTimeout(function () {
        b.texture = t.hoverTexture;
        if (t.elastic) {
          b.targetScale = 1.05;
          if (b.poinerDownEnded) {
            TweenMax.to(b, 0.3, {
              pixi: {
                scale: b.targetScale,
              },
              ease: Elastic.easeOut.config(1, 0.45),
            });
          }
        }
      }, 50);
    }
  };
  t.on("mouseup", t.onMouseUp);

  t.onPointerDown = function () {
    b.texture = t.pressedTexture;
    t.isPressed = true;
    if (t.elastic) {
      b.poinerDownEnded = false;
      b.pointerUpStarted = false;
      TweenMax.to(b, 0.1, {
        pixi: {
          scale: 0.95,
        },
        onComplete: function () {
          b.poinerDownEnded = true;
          if (b.pointerUpStarted) {
            TweenMax.to(b, 0.3, {
              pixi: {
                scale: b.targetScale,
              },
              ease: Elastic.easeOut.config(1, 0.45),
            });
          }
        },
      });
    }
  };
  t.on("pointerdown", t.onPointerDown);

  t.onMouseOver = function () {
    b.texture = t.hoverTexture;
    if (t.elastic) {
      TweenMax.to(b, 0.5, {
        pixi: {
          scale: 1.05,
        },
        ease: Elastic.easeOut.config(1, 0.45),
      });
    }
  };
  t.on("mouseover", t.onMouseOver);

  t.onMouseOut = function () {
    b.texture = t.defaultTexture;
    t.isPressed = false;
    if (t.elastic) {
      TweenMax.to(b, 0.1, {
        pixi: {
          scale: 1,
        },
      });
    }
  };
  t.on("mouseout", t.onMouseOut);

  parent.addChild(t);

  //methods

  t.disable = function () {
    t.interactive = false;
    setTimeout(function () {
      b.texture = t.disabledTexture;
      if (t.elastic) {
        b.scale.set(1);
      }
    }, 50);
  };

  t.enable = function () {
    t.interactive = true;
    setTimeout(function () {
      b.texture = t.defaultTexture;
      if (t.elastic) {
        b.scale.set(1);
      }
    }, 50);
  };

  t.getName = function () {
    return t.type + " - " + t.defaultTexture.textureCacheIds[0];
  };

  t.delete = function () {
    var elLength = t.children.length;
    for (var i = elLength - 1; i >= 0; i--) {
      t.children[i].delete();
    }

    t.off("mouseout", t.onMouseOut);
    t.off("mouseover", t.onMouseOver);
    t.off("touchendoutside", t.onTouchOutside);
    t.off("touchend", t.onTouchEnd);
    t.off("mouseup", t.onMouseUp);
    t.off("pointerdown", t.onPointerDown);
    if (t.onPointerUp) {
      t.off("pointerup", t.onPointerUp);
    }

    parent.removeChild(t);
    t.destroy();
    t = null;
  };

  return t;
}

//ButtonGroup class

function ButtonGroup(arrayOfButtons, initSelection) {
  arrayOfButtons = arrayOfButtons || [];
  if (initSelection == undefined) initSelection = -1;
  var bg = {};
  bg.list = [];
  if (arrayOfButtons.length > 0 && initSelection) bg.selectedButton = arrayOfButtons[initSelection];

  bg.selectedIndex = initSelection;

  bg.addButton = function (button) {
    bg.list.push(button);
    button.group = bg;
    button.onPointerUp = function (e) {
      if (!button.isPressed && e != null) return;

      var t = button;
      for (var i = 0; i < t.group.list.length; i++) {
        var btn = t.group.list[i];
        if (btn == t) continue;
        btn.interactive = true;

        btn.frontRect.y = btn.frontRect.startY;
        btn.textBox.y = btn.textBox.startY;
        btn.textBox.style = btn.style.textStyle;
        fadeToColor(btn.frontRect, btn.style.fill1[0], btn.style.fill1[1], btn.style.fadeDuration);
        fadeToColor(btn.frontLine, btn.style.line1[1], btn.style.line1[2], btn.style.fadeDuration);

        fadeToColor(btn.backRect, btn.style.fill2[0], btn.style.fill2[1], btn.style.fadeDuration);
        fadeToColor(btn.backLine, btn.style.line2[1], btn.style.line2[2], btn.style.fadeDuration);
        btn.textBox.style = btn.style.textStyle;
        if (btn.img) {
          fadeToColor(btn.img, btn.style.imgColor[0], btn.style.imgColor[1], btn.style.fadeDuration);
          btn.img.y = btn.img.startY;
        }
      }
      t.group.selectedButton = t;
      t.group.selectedIndex = t.group.list.indexOf(t);

      t.interactive = false;
      if (t.callback) t.callback(e);
      t.frontRect.y = t.frontRect.downY;
      t.textBox.y = t.textBox.downY;
      t.textBox.style = t.style.selectedTextStyle;
      fadeToColor(t.frontRect, t.style.selectedFill1[0], t.style.selectedFill1[1], t.style.fadeDuration);
      fadeToColor(t.frontLine, t.style.selectedLine1[1], t.style.selectedLine1[2], t.style.fadeDuration);

      fadeToColor(t.backRect, t.style.selectedFill2[0], t.style.selectedFill2[1], btn.style.fadeDuration);
      fadeToColor(t.backLine, t.style.selectedLine2[1], t.style.selectedLine2[2], t.style.fadeDuration);
      if (t.img) {
        fadeToColor(btn.img, btn.style.selectedImgColor[0], btn.style.selectedImgColor[1], btn.style.fadeDuration);
        t.img.y = t.img.downY;
      }
    };
    button.on("pointerup", button.onPointerUp);
  };

  bg.removeButton = function (button) {
    bg.list.splice(bg.list.indexOf(button), 1);
    button.off("pointerup", button.onPointerUp);
    button.group = null;
    button.onPointerUp = null;
    bg.selectedIndex = bg.list.indexOf(bg.selectedButton);
    if (button == bg.selectedButton) bg.selectedButton = null;
  };

  for (var i = 0; i < arrayOfButtons.length; i++) {
    bg.addButton(arrayOfButtons[i]);
  }

  if (initSelection > -1) arrayOfButtons[initSelection].onPointerUp();

  return bg;
}
